import { createFilterStore } from './createFilterStore';

export const useTaskFilterStore = createFilterStore({
  page: 1,
  limit: 20,
  search: '',
  status: '',
  priority: '',
  assignedToId: '',
  sortBy: 'dueDate',
  sortOrder: 'asc' as const,
});
